"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TPBURLCoder = exports.URLDecodeError = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
const lodash_1 = require("lodash");
class URLDecodeError extends Error {
}
exports.URLDecodeError = URLDecodeError;
class TPBURLCoder {
    /**
     * 3社間調整のURLをdecodeする
     *
     * @param url 3社間調整のURL /matsumotokazuya/tp/xxxxxx
     * @returns   デコードしたObject { uid: 'vtGNajTOKkegzJS6aOIu', bookingId: 'sAMbKJzs6BNa4jcA9PKK' }
     */
    static decode(url) {
        const result = url.match(this.REGEX);
        const groups = result === null || result === void 0 ? void 0 : result.groups;
        if ((0, lodash_1.isEmpty)(groups) || (0, lodash_1.isEmpty)(groups.uid) || (0, lodash_1.isEmpty)(groups.bookingId)) {
            throw new URLDecodeError(`Fail to decode url ${url}`);
        }
        return {
            uid: groups.uid,
            bookingId: groups.bookingId
        };
    }
}
exports.TPBURLCoder = TPBURLCoder;
TPBURLCoder.REGEX = /\/(?<uid>.*)\/tpb\/(?<bookingId>[^? | ^/]*)([? | /].*)?/;
//# sourceMappingURL=TpbUrlCoder.js.map